import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  outbound_items_forms: [],
};

const getters = {
  allOutboundItemsForms: (state) => state.outbound_items_forms,
};

const actions = {
  async fetchOutboundItemsForms({ commit }, params = {}) {
    try {
      const response = await axios.get("/outbound-items-form", { params: prm(params) });
      commit("setOutboundItemsForms", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch outbound_items_forms:", error);
    }
  },
  async createOutboundItemsForm({ commit }, outbound_items_form) {
    try {
      const response = await axios.post("/outbound-items-form", outbound_items_form);
      commit("addOutboundItemsForm", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create outbound_items_form:", error);
      throw error;
    }
  },
  async fetchOutboundItemsFormById(_, id) {
    try {
      const response = await axios.get(`/outbound-items-form/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch outbound_items_form:", error);
      throw error;
    }
  },
  async updateOutboundItemsForm({ commit }, outbound_items_form) {
    try {
      const response = await axios.put(`/outbound-items-form/${outbound_items_form.id}`, outbound_items_form);
      commit("updateOutboundItemsForm", response.data);
    } catch (error) {
      console.error("Failed to update outbound_items_form:", error);
      throw error;
    }
  },
  async closeOutboundItemsForm({ commit }, outbound_items_form) {
    try {
      const response = await axios.post(`/outbound-items-form/close`, outbound_items_form);
      commit("closeOutboundItemsForm", response.data);
    } catch (error) {
      console.error("Failed to close outbound_items_form:", error);
      throw error;
    }
  },
  async deleteOutboundItemsFormById({ commit }, id) {
    try {
      const response = await axios.delete(`/outbound-items-form/${id}`);
      commit("removeOutboundItemsForm", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete outbound_items_form:", error);
      throw error;
    }
  },
};

const mutations = {
  setOutboundItemsForms(state, outbound_items_forms) {
    state.outbound_items_forms = outbound_items_forms.data; // Ensure this matches your API's response structure
  },
  addOutboundItemsForm(state, outbound_items_form) {
    state.outbound_items_forms.push(outbound_items_form);
  },
  updateOutboundItemsForm(state, updatedOutboundItemsForm) {
    const index = state.outbound_items_forms.findIndex(
      (outbound_items_form) => outbound_items_form.id === updatedOutboundItemsForm.id
    );
    if (index !== -1) {
      state.outbound_items_forms.splice(index, 1, updatedOutboundItemsForm);
    }
  },
  removeOutboundItemsForm(state, id) {
    state.outbound_items_forms = state.outbound_items_forms.filter(
      (outbound_items_form) => outbound_items_form.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
